// extracted by mini-css-extract-plugin
export default {"select_container":"Diet-add-form_select_container__N1gdP","form_input_field":"Diet-add-form_form_input_field__SJ8EG","plan_form_field":"Diet-add-form_plan_form_field__HeOo1"};